import { Action, Selector, State, StateContext, Store } from "@ngxs/store";
import { ClaimStateModel } from "./claim-model";
import { Injectable } from "@angular/core";
import { EncounterService } from "../../services/encounter.service";
import { Parties, UserService } from "@harlowe/core"
import { MessageService } from "primeng/api";
import { Encounters } from "../encounters/encounter-actions";
import { Claims } from "./claim-actions";
import { EncounterStateModel } from "../encounters/encounter-model";
import { iif, insertItem, patch, removeItem, updateItem } from "@ngxs/store/operators";
import { lastValueFrom } from "rxjs";
import { EncounterState } from "../encounters/encounter-state";
import { instanceToInstance, plainToClass, plainToInstance } from "class-transformer";
import { TealCompClaim } from "../../models/teal-comp-claim";
import { Party } from "@harlowe/core";
import { PartyService } from "@harlowe/core";


@State<ClaimStateModel>
(
    {
        name: "claims",
        defaults: 
        {
            openClaims: [],
            selectedClaim: undefined,
            selectedClaimIndex: 0
        }
    }
)

@Injectable()
  export class ClaimState 
  {

    constructor
    (
        private _encounterService: EncounterService,
        private _userService: UserService,
        private _messageService: MessageService,
        private _partyService: PartyService,
        private _store: Store
    )
    {

    }

    @Selector()
    static openClaims(state: ClaimStateModel) 
    {
      return state.openClaims;
    }

    @Selector()
    static selectedClaim(state:ClaimStateModel)
    {
        return state.selectedClaim;
    }

    @Selector()
    static selectedClaimIndex(state:ClaimStateModel)
    {
        return state.selectedClaimIndex;
    }

    @Selector()
    static selectedClaimId(state:ClaimStateModel)
    {
        return state.selectedClaim?.id;
    }


    @Action([Claims.UserLoggedIn])
    async userLoggedIn(ctx: StateContext<ClaimStateModel>, action: Claims.UserLoggedIn)
    {
        var persistedState =   (await this._userService.getSetting<ClaimStateModel>("claimState"));


        if(!persistedState)
        {
            //Initialize state
            await this._userService.setSetting("claimState",ctx.getState());
        }
        else
        {
            //Convert claims to instances of claims
            persistedState.openClaims = persistedState.openClaims.map(c => plainToClass(TealCompClaim,c));
            if(persistedState.selectedClaim)
                persistedState.selectedClaim = plainToClass(TealCompClaim,persistedState.selectedClaim);
            
            ctx.setState
            (
                persistedState
            )
        }
    }

    @Action([Encounters.EncounterSelected])
    async encounterSelected(ctx: StateContext<ClaimStateModel>, action: Encounters.EncounterSelected)
    {
        //Jump to that claim
        // var state=ctx.getState();
        var openEncounters = this._store.selectSnapshot(EncounterState.openEncounters);
        var encounter = openEncounters[action.payload.index];

        if(encounter.referral.claim)
            await lastValueFrom(ctx.dispatch(new Claims.ClaimStateOpenClaim({claim: encounter.referral.claim})));
    }

    @Action([Encounters.WorkbenchEncounterClosed])
    async encounterClosed(ctx:StateContext<ClaimStateModel>, action: Encounters.WorkbenchEncounterClosed)
    {
        //Close the claim for this encoutner if no other encounters are open for it
        var openEncounters = this._store.selectSnapshot(EncounterState.openEncounters).filter(e => e.id != action.payload.encounter.id);
        var claim = action.payload.encounter.referral.claim;
        var claimId = action.payload.encounter.referral.claim?.id;
        if(claim)
        {
            var otherEncountersForThisClaim = openEncounters.filter(e => e.referral.claim?.id == claimId);
            if(!otherEncountersForThisClaim || otherEncountersForThisClaim.length == 0)
            {
                //We can close this claim
                await lastValueFrom(ctx.dispatch(new Claims.ClaimStateCloseClaim({claim:claim})));
            }

        }
    }

    @Action([Parties.PartyServiceAddressAdded,Parties.PartyServiceAddressUpdated,Parties.PartyServiceAddressDeleted,
                Parties.PartyServiceEmailAdded,Parties.PartyServiceEmailUpdated,Parties.PartyServiceEmailDeleted,
                Parties.PartyServicePhoneAdded,Parties.PartyServicePhoneUpdated,Parties.PartyServicePhoneDeleted])
    async addressAdded(ctx:StateContext<ClaimStateModel>,action: Parties.PartyServiceAddressAdded | Parties.PartyServiceAddressUpdated | Parties.PartyServiceAddressDeleted|
                                                                    Parties.PartyServiceEmailAdded|Parties.PartyServiceEmailUpdated|Parties.PartyServiceEmailDeleted|
                                                                    Parties.PartyServicePhoneAdded|Parties.PartyServicePhoneUpdated|Parties.PartyServicePhoneDeleted)
    {
        var p = await this._partyService.getParty(action.payload.partyId);
        ctx.dispatch(new Claims.PartyStatePartyUpdated({party:p}))
    }

    @Action([Claims.ClaimServiceCarrierUpdated])
    async carrierUpdated(ctx:StateContext<ClaimStateModel>,action:Claims.ClaimServiceCarrierUpdated)
    {
        var state = ctx.getState();
        var openClaims = state.openClaims.map(c => instanceToInstance(c));
        var claimsWithCarrier = openClaims.filter(c => c.carrier?.id == action.payload.carrier.id);

        if(claimsWithCarrier.length >0)
        {
            claimsWithCarrier.forEach(c => c.carrier = action.payload.carrier);
            ctx.setState
            (
                {
                    ...state,
                    openClaims: [... claimsWithCarrier, ... openClaims.filter(c => !claimsWithCarrier.map(cc => cc.id).includes(c.id))]
                }
            )
        }
    }

    @Action([Claims.ClaimServiceAdjusterUpdated])
    async adjusterUpdated(ctx:StateContext<ClaimStateModel>,action:Claims.ClaimServiceAdjusterUpdated)
    {
        var state = ctx.getState();
        var openClaims = state.openClaims;
        var claimsWithAdjuster = openClaims.filter(c => c.adjuster?.id == action.payload.adjuster.id);

        if(claimsWithAdjuster.length >0)
        {
            claimsWithAdjuster.forEach(a => a.adjuster = action.payload.adjuster);
            ctx.setState
            (
                {
                    ...state,
                    openClaims: [... claimsWithAdjuster, ... openClaims.filter(c => !claimsWithAdjuster.map(cc => cc.id).includes(c.id))]
                }
            )
        }
    }



    @Action([Claims.ClaimServiceClaimUpdated])
    async claimUpdated(ctx:StateContext<ClaimStateModel>,action:Claims.ClaimServiceClaimUpdated)
    {
        var state = ctx.getState();

        var openClaimIds = state.openClaims.map(c => c.id);

        //Patch the open claims and selected claim with this (if it's a match)
        ctx.setState
        (
            iif(openClaimIds.includes(action.payload.claim.id),
            patch
            (
                {
                    openClaims: updateItem<TealCompClaim>
                    (
                        item => item.id == action.payload.claim.id,
                        action.payload.claim
                    ),
                    selectedClaim: iif(state.selectedClaim?.id == action.payload.claim.id,action.payload.claim)
                }
            ))
        )

        await lastValueFrom(ctx.dispatch(new Claims.PersistState()));
    }


    @Action([Parties.PartyServicePartyUpdated, Claims.PartyStatePartyUpdated])
    async partyUpdated(ctx:StateContext<ClaimStateModel>, action: Parties.PartyServicePartyUpdated | Claims.PartyStatePartyUpdated)
    {
        //Find any claims this party is on
        var state = ctx.getState();

        var partyClaims = instanceToInstance([...state.openClaims.filter(c => c.party.id == action.payload.party.id)]);
        var newParty = plainToInstance(Party, action.payload.party);

        //update the party on each claim. Since these are just the 'open claims' we can do this without worrying about enw instances of the party
        //in each claim
        partyClaims.forEach(c => c.party = newParty);
        ctx.setState
        (
            {
                ...state,
                openClaims: [...partyClaims,...state.openClaims.filter(c => !partyClaims.map(pc => pc.id).includes(c.id))],
                selectedClaim: (state.selectedClaim && partyClaims.map(pc => pc.id).includes(state.selectedClaim.id)) ? partyClaims.find( pc => pc.id == state.selectedClaim?.id) : state.selectedClaim 

            }
        )

        await lastValueFrom(ctx.dispatch(new Claims.PersistState()));

        await lastValueFrom(ctx.dispatch(new Claims.PersistState()));

    }


    @Action([Claims.ClaimServiceOpenClaim, Claims.ClaimStateOpenClaim])
    async claimOpened(ctx:StateContext<ClaimStateModel>, action: Claims.ClaimServiceOpenClaim | Claims.ClaimStateOpenClaim)
    {
        //Add the claim to our list of claims if it isn't already opened
        //Also, select that claim in the list

        var state = ctx.getState();
        var openClaimIds = state.openClaims.map(c => c.id);
        var claimId = action.payload.claim.id;
        var claim = action.payload.claim;
        var selectedIndex = openClaimIds.indexOf(claimId);

        ctx.setState
        (

            //Insert the claim
            iif(!openClaimIds.includes(claimId),
                patch<ClaimStateModel>
                (
                    {
                        openClaims: insertItem
                        (
                            claim
                        ),
                    }
                    
                ),
                patch<ClaimStateModel>
                ({
                    openClaims: updateItem
                    (
                        item => item.id === claimId,
                        claim
                    ),
                })
                )            
        )
        ctx.setState
        (
            //now, select the claim
            patch<ClaimStateModel>
            (
                {
                    selectedClaim: claim,
                    selectedClaimIndex: Math.max(selectedIndex,0)       //If we just inserted, the index will be 0 (selectedIndex will be -1 since we didn't find it initially)
                }
            )
        )

        await lastValueFrom(ctx.dispatch(new Claims.PersistState()));


    }

    @Action([Claims.ClaimStateCloseClaim])
    async claimClosed(ctx:StateContext<ClaimStateModel>, action: Claims.ClaimStateCloseClaim)
    {
        //Remove the open claim from the list
        
        var state = ctx.getState();
        var selectedClaimID = state.selectedClaim?.id;
        
        ctx.setState
        (
            patch<ClaimStateModel>
            (
                {
                    openClaims: removeItem(item => item.id == action.payload.claim.id)                    
                }
            )
        )
        
        if(selectedClaimID && selectedClaimID == action.payload.claim.id)
        {
            ctx.setState
            (
                patch<ClaimStateModel>
                (
                    {
                        selectedClaim: undefined,
                        selectedClaimIndex: 0
                    }
                )
            )
        }


        await lastValueFrom(ctx.dispatch(new Claims.PersistState()));

 
    }



    @Action([Claims.ClaimCardClaimClosed])
    async claimCardCloseClaim(ctx:StateContext<ClaimStateModel>, action: Claims.ClaimCardClaimClosed)
    {
        //Close all encounters associated with this claim. The last encounter closed will trigger the claim to be closed as well
        var openEncounters = this._store.selectSnapshot(EncounterState.openEncounters);
        var claimEncounters = openEncounters.filter(e => e.referral.claim && e.referral.claim.id ==action.payload.claim.id);

        //If we have no encounters open for this claim
        if(!claimEncounters || claimEncounters.length == 0)
        {
            //Just close this guy
            await lastValueFrom(ctx.dispatch(new Claims.ClaimStateCloseClaim({claim:action.payload.claim})))
        }
        else
        {
            claimEncounters.forEach
            (
                async e => await lastValueFrom(ctx.dispatch(new Encounters.WorkbenchEncounterClosed({encounter:e})))
            )
        }

    }


    @Action([Claims.PersistState])
    async persistState(ctx:StateContext<ClaimStateModel>)
    {
        var state = ctx.getState();

        await this._userService.setSetting("claimState",state);

    }

}

